export enum CardLimitType {
  LIMIT_5000 = 5000,
  LIMIT_10000 = 10000,
  LIMIT_20000 = 20000,
  LIMIT_OTHER = -1,
}
